import { Injectable } from '@angular/core';
import { GetActiveVoucherDto } from '../models/courier.models';
import { StartNewVoucherDataClass } from '../models/start-new-voucher-data.model';

@Injectable({
  providedIn: 'root'
})
export class ActiveUserLocalDataService {
  private activeCourierVoucher: GetActiveVoucherDto | null = null;
  private startNewVoucherData: StartNewVoucherDataClass | null = null;
  public visualDamageType: string = '';
  public visualDamageDeffectPositionId: number | null = null;
  public visualDamageDeffectPosition: string | null = null;
  public activeServiceVoucherId: number | undefined = undefined;
  public activeServiceVoucher: GetActiveVoucherDto | null = null;
  public activeServiceCarNumber: string | null = null;
  public newServiceVoucherCarId: number | null = null;
  public newServiceVoucherComments: string[] | null = null;
  public newServiceFixExistingCarFaultsList: number[] = [];
  public newServiceVoucherServiceId: number | undefined = undefined;

  setActiveCourierVoucher(voucher: GetActiveVoucherDto | null) {
    this.activeCourierVoucher = voucher;
  }

  getActiveCourierVoucher(): GetActiveVoucherDto | null {
    return this.activeCourierVoucher;
  }

  setStartNewVoucherData(voucherData: StartNewVoucherDataClass) {
    this.startNewVoucherData = voucherData;
  }

  getStartNewVoucherData(): StartNewVoucherDataClass | null {
    return this.startNewVoucherData;
  }

  setActiveServiceVoucherId(voucherId: number) {
    this.activeServiceVoucherId = voucherId;
  }
}